// @flow

import type {
  FlatAst,
  BaseTermType,
  FilterType
} from '../../../types/luceneTypes';

export function negateTermType(type: BaseTermType): FilterType {
  switch (type) {
    case 'range':
      return 'not_range';
    case 'exists':
      return 'not_exists';
    case 'contains':
      return 'not_contains';
    case 'starts_with':
      return 'not_starts_with';
    case 'ends_with':
      return 'not_ends_with';
    case 'equals':
    default:
      return 'not_equals';
  }
}

export function deriveField(flatAst: FlatAst): string {
  if (
    flatAst.statements[0].ast.field &&
    flatAst.statements[0].ast.field !== '<implicit>'
  ) {
    return flatAst.statements[0].ast.field;
  }
  return flatAst.explicitField || '';
}

export function deriveTerm(flatAst: FlatAst): ?string {
  if (flatAst.statements[0] && flatAst.statements[0].ast.term) {
    return flatAst.statements[0].ast.term;
  }
  return undefined;
}

export function reconstructTerm(term: string, type: FilterType): string {
  switch (type) {
    case 'exists':
    case 'not_exists':
      return '*';
    case 'contains':
    case 'not_contains':
      return `*${term}*`;
    case 'starts_with':
    case 'not_starts_with':
      return `${term}*`;
    case 'ends_with':
    case 'not_ends_with':
      return `*${term}`;
    default:
      return term;
  }
}
